import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { fetchCompanyBlogs } from "../redux/slices/blogSlice";

import { CalendarDays } from "lucide-react";

// ================= BASE URL =================
const newPath = "http://erp.metasolution.in/uploads/";

const BlogDetail = () => {

  const { id } = useParams();

  const dispatch = useDispatch();

  const {
    blogs: companyBlogs,
    loading,
    error,
  } = useSelector((state) => state.blog);

  // ================= FETCH BLOGS =================
  useEffect(() => {
    if (!companyBlogs?.length) {
      dispatch(fetchCompanyBlogs(1));
    }
  }, [dispatch, companyBlogs]);

  // ================= FIND BLOG =================
  const blog = companyBlogs?.find(
    (item) => item.id.toString() === id
  );

  // ================= IMAGE FIX =================
  const imageUrl = blog?.image1
    ? `${newPath}${blog.image1.split("\\").pop()}`
    : null;

  console.log("BLOG ID:", id);
  console.log("FOUND BLOG:", blog);
  console.log("IMAGE URL:", imageUrl);

  // ================= LOADING =================
  if (loading || !companyBlogs?.length) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  // ================= ERROR =================
  if (error) {
    return (
      <div className="text-center py-20 text-red-500 font-bold">
        {typeof error === "string" ? error : error?.message}
      </div>
    );
  }

  // ================= NOT FOUND =================
  if (!blog) {
    return (
      <div className="text-center py-32">
        <h2 className="text-4xl font-black text-red-500">
          Blog Not Found
        </h2>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-white to-blue-50 py-14 px-4">

      <div className="max-w-5xl mx-auto bg-white rounded-[35px] shadow-xl overflow-hidden border border-gray-100">

        {/* ================= IMAGE ================= */}
        {/* {imageUrl && (
          <img
            src={imageUrl}
            alt={blog.title}
            className="w-full h-[450px] object-cover"
          />
        )} */}

        {/* ================= CONTENT ================= */}
        <div className="p-8 md:p-12">

          {/* CATEGORY */}
          <span className="inline-flex items-center px-5 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-bold">
            {blog.categoryName || "General"}
          </span>

          {/* TITLE */}
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mt-6">
            {blog.title}
          </h1>

          {/* DATE */}
          <div className="flex items-center gap-2 text-gray-500 mt-5">
            <CalendarDays size={18} />
            <span>
              {blog.addedDate
                ? blog.addedDate.split("T")[0]
                : "N/A"}
            </span>
          </div>

          {/* CONTENT */}
          <div
            className="mt-10 text-gray-700 leading-8 text-lg"
            dangerouslySetInnerHTML={{
              __html: blog.content,
            }}
          />

        </div>

      </div>
    </div>
  );
};

export default BlogDetail;